<template>
  <HeadingLv1 text="保存した検索条件" />
  <div class="u-containar">
    <MypageContents>
      <SavedSearchCondition :showCount="5" :canDelete="true" />
      <BackTo link="/mypage" />
    </MypageContents>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import SavedSearchCondition from '@/components/block/SavedSearchCondition.vue'
import BackTo from '@/components/block/BackTo.vue'

export default defineComponent({
  components: {
    HeadingLv1,
    MypageContents,
    SavedSearchCondition,
    BackTo
  }
})
</script>
